<template>
  <div class="card" :style="{ height: '26em' }">
    <chartAlert :data="alerts" />
  </div>
</template>
<script>
import chartAlert from '@/components/charts/chart-alert';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'RecentAlertOverview',
  components: {
    chartAlert,
  },
  data: function () {
    return {
      alerts: [],
      loadingAlert: true,
    };
  },
  computed: {
    ...mapGetters('globalState/settings', ['getDurationTime']),
    ...mapState('homeState', ['recentAlert']),
  },
  methods: {
    ...mapActions('apmState/apmCommonState', [
      'selectEndpoint',
      'selectService',
    ]),
    ...mapActions('homeState', ['GET_RECENT_ALERTS']),
    async loadAlarm() {
      const params = {
        duration: this.getDurationTime,
        serviceReq: {
          capability: 'APM',
        },
      };
      try {
        await this.GET_RECENT_ALERTS(params);
      } catch (error) {
        console.log('error', error);
      } finally {
        this.loadingAlert = false;
      }
      this.alerts = this.recentAlert;
      //console.log('loadService', this.recentAlert);
    },
  },
  mounted: function () {
    this.loadAlarm();
  },
  watch: {
    getDurationTime: function (newValue, oldValue) {
      this.loadAlarm();
    },
  },
};
</script>
